import { BrSubregion, brSubregions } from "./br_subregion";
import { PhSubregion, phSubregions } from "./ph_subregion";

export type Subregion = PhSubregion | BrSubregion;

export const allSubregions = [...phSubregions, ...brSubregions];
